<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
    <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="validateForm" @success="onSuccess"> -->
    
    <z-page :title="title">
    <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column" >
           <div class="grow " >
           <z-select class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getTernakan(form)" :validators="[validators.required]"/>
           <br>
           <div class="w-flex wrap smd-column" >
      <div class="grow " >
          <div style="margin:5px;" class="fw-normal my1 fs-1"><b> Pasung : </b><w-radios
                class="mr2"
                v-model="form.pasung"
                :items="pasung_list"
                inline
                color="blue-light1">
              </w-radios></div>
          </div>
        </div>
           </div>
           <div class="mx2"></div>
           <div class="grow " >
           <br>
           <template v-if="form.lkp_negeri_id">
            <div style="margin:23px;" class="fw-normal my1 fs-1"><b>Negeri : </b>{{form.lkp_negeri}}</div>
           <!-- <w-input style="margin:5px; " class="mt4" :items="lkp_negeri" label="Negeri"  v-model="form.lkp_negeri_id" :validators="[validators.required]"  /> -->
         </template>
         </div>
       </div>
       <br>
       <span style="color: red"><h2> **Sila hubungi Jurusuntik/Juruteknik yang dipilih sebelum menghantar permohonan</h2></span>
    <br>
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
        <z-select class="mt4"  outline :items="lkp_art" label="Jenis Perkhidmatan*" v-model="form.lkp_art_id" @input="getJuruteknik(form)" :validators="[validators.required]"/>
        <template  v-if="form.lkp_art_id==2">
        <z-select class="mt4"  outline :items="lkp_tujuan" label="Tujuan PD*" v-model="form.lkp_tujuan_id" @input="getTernakan(form)" :validators="[validators.required]"/>
      </template>
      <template v-if="form.lkp_art_id ==1">
         <z-select class="mt4" label="Jenis Berahi*" outline :items="lkp_berahi" v-model="form.lkp_berahi_id" :validators="[validators.required]"/>
      </template>
      <z-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getTernakan(form)"  :validators="[validators.required]"/>
     </div>
      <div class="mx2"></div>
      <div class="grow " >
         <template v-if="form.lkp_art_id ==1">
           <w-input class="mt4"  label="Tarikh Pengesanan Berahi" type="date" :max="tarikh_today" v-model="form.tarikh_pengesanan_biang" outline />  
           <w-input class="mt4"  label="Waktu Pengesanan Berahi" type="time" v-model="form.masa_pengesanan_biang" outline />  
         </template>
         <template v-if="form.lkp_art_id == 2 ">
            <w-input class="mt4"  label="Tarikh Temujanji PD" type="date" v-model="form.tarikh_datang_pemeriksaan" outline />
         </template>
         <z-select class="mt4" outline :items="juruteknik_list" label="Nama Juruteknik/Jurusuntik *"  v-model="form.juruteknik_id"  :validators="[validators.required]"/>
      </div>
    </div>
    <br>
    <div class="w-table-wrap" style="max-height: 400px;">
      <div class="table-profil-scrol">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">BIL</th>
              <th class="w-table__header  text-left">ID TERNAKAN | NAMA</th>
               <template v-if="form.lkp_art_id == 2">
              <th class="w-table__header  text-left">NO KES AI/ET</th>
              <th class="w-table__header  text-left">TARIKH SUNTIKAN TERAKHIR/ NAMA JURUTEKNIK JURUSUNTIK</th>
              </template>
              <th class="w-table__header  text-left">JANTINA</th>
              <th class="w-table__header  text-left">UMUR (BULAN)</th>
              <th class="w-table__header  text-left">BAKA</th>
              <th class="w-table__header  text-left">STATUS</th>
              <th class="w-table__header  text-left">TARIKH SUNTIKAN TERDAHULU</th>
              <th class="w-table__header  text-left">TARIKH BERANAK TERDAHULU</th>
              <template v-if="form.lkp_art_id == 1">
              <th class="w-table__header  text-left">JENIS PILIHAN SEMEN</th>
              </template>
              <th class="w-table__header  text-left"><w-checkbox v-model="checkin" @change="klickPilih()" ></w-checkbox></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="ternakan_list.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="9"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan_list">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}} | {{dt.nama_ternakan}}</td>
                <template v-if="form.lkp_art_id == 2">
                <td class="w-table__cell text-left" >{{dt.no_kes}}</td>
                <td class="w-table__cell text-left" >{{dt.jurusuntik}}</td>
                </template>
                <td class="w-table__cell text-left" >{{dt.jantina}}</td>
                <td class="w-table__cell text-left" >{{$zutil.umurBln(dt.tarikh_lahir)}}</td>
                <td class="w-table__cell text-left" >{{dt.baka}}</td>
                <td class="w-table__cell text-left" >{{dt.status}}</td>
                <td class="w-table__cell text-left" >{{$zutil.dateformat(dt.tarikh_suntik)}}</td>
                <td class="w-table__cell text-left" >{{$zutil.dateformat(dt.tarikh_beranak)}}</td>
                <template v-if="form.lkp_art_id == 1">
                  <w-select style="margin:5px;" class="mt4" placeholder="Pilih Satu.." @input="klickSemen(dt)" outline :items="lkp_baka" v-model="dt.jenis_semen"/>
                </template>
                <td class="w-table__cell text-center"><div class="title4 mb2"></div><w-checkbox v-model="dt.pilih" @input="klickPi(dt)"></w-checkbox>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        </div>
      </div>
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
        <w-button class="my1"   :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
        <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </div>
  </z-page>
    </w-form>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  

  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan Pembiakan', route: '/art' },
        { label: 'Permohonan ART', route: '/art/permohonan' },
        { label: 'Form', route: '/art/permohonan' },
      ],
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      negeri : '',
      title : 'ART  Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      ternakan_list:[],
      premis : [],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      lkp_art : [],
      lkp_tujuan :[],
      lkp_berahi: [],
      loading : 0,
      lkp_baka:[],
      checkin:false,
      tarikh_today:'',
    
    }
  },
  methods: {
      klickSemen(dt){
         if (dt.jenis_semen == 0) {
            dt.pilih = false;
         }else{
            dt.pilih = true;
         }

         if(dt.pilih == false){
            dt.jenis_semen = 0
         }
      },
      klickPi(dt){
         if(dt.pilih == false){
            dt.jenis_semen = 0;
         }
      },
    lkpBerahi()
    {
      this.$zcomm.get(this.api_service + 'lookup/berahi', {}).then(res => {
        this.lkp_berahi = res
      })
    },
    validateForm() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         for (var i in this.ternakan_list) {
            if (this.form.lkp_art_id == 1 && (this.ternakan_list[i].pilih==false && this.ternakan_list[i].jenis_semen!=0 || this.ternakan_list[i].jenis_semen==0 && this.ternakan_list[i].pilih==true)) {
               isValid = false;
               break;
            }

            if(this.form.lkp_art_id == 1 && this.ternakan_list[i].pilih==true && this.ternakan_list[i].jenis_semen!=0){
               jumlah_lulus = 1;
            }else if((this.form.lkp_art_id == 2 || this.form.lkp_art_id == 3) && this.ternakan_list[i].pilih==true )
            {
               jumlah_lulus = 1;
            }
            // {
            //    if (row.pilih!=false && row.jenis_semen!=0) {
            //       isValid = true;
            //       return false;
            //    }else if (!row.jenis_semen || !row.pilih) {
            //       isValid = false;
            //       this.loading=false;
            //       // return true;
            //    }
            // }else{
            //    if (row.pilih!=false) {
            //       isValid = true;
            //       return false;
            //    }else if (!row.pilih) {
            //       isValid = false;
            //       this.loading=false;
            //       // return true;
            //    }
            // }
         };
      if(!this.form.premis_id || !this.form.lkp_art_id || !this.form.juruteknik_id || !this.form.lkp_ternakan_id){
         isValid = false;
      }else if(this.form.lkp_art_id == 1 && (!this.form.lkp_berahi_id)){
         isValid = false;
      }else if(this.form.lkp_art_id == 2 && (!this.form.lkp_tujuan_id)){
         isValid = false;
      }
      if(jumlah_lulus == 0 && isValid == true){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.form.hantar = hantar
    },

    klickPilih(){
        for (var b in this.ternakan_list) {
            this.ternakan_list[b].pilih = this.checkin
        }
    },
    onSuccess(){
      this.form.ternakan_list = this.ternakan_list;
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      this.$inertia.visit(this.$route('art.semakan.index'));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }else{
                this.$zcomm.post(this.resourceurl+'.store' , this.form)
                .then(res => {
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);
                  this.$inertia.visit(window.route('art.semakan.index',res.id));

                })
              }
            }
          })
      }else{
        if (this.form.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('art.semakan.index'));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.permohonan.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
        else 
        {
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('art.permohonan.form', res.id));

          })
        }
      } 
      
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
        if (this.premis.length == 1) {
         for (var p in this.premis) {
            this.form.premis_id = this.premis[p].value;
            this.form.lkp_negeri_id = this.premis[p].lkp_negeri_id;
            this.form.lkp_negeri = this.premis[p].lkp_negeri;
         }
        }
      })
    },

    getData(){
      this.getTernakan(this.d_form);
      this.getJuruteknik(this.d_form);
    },

    getTernakan(data){
      if(data.lkp_art_id!=2){
        data.lkp_tujuan_id = 0;
      }
      if(data.premis_id !='' && data.lkp_ternakan_id !=''){
        this.$zcomm.get(this.api_service + 'ternakan/tidak_bunting/'+data.premis_id+'/'+data.lkp_ternakan_id+'/'+data.lkp_tujuan_id, {}).then(res => {
          this.ternakan_list = res
          if(data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) 
              {
                if(this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].jenis_semen = data.ternakan_list[t].jenis_semen;
                }
              }
            }

          }
        })

      }
      for (var b in this.premis) 
      {
        if(this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
          this.getJuruteknik(data);
        }
      }
      
    },



    getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
         if(data.lkp_berahi_id!=2){
            var lkp_berahi_id = 0;
         }else{
            var lkp_berahi_id = data.lkp_berahi_id;
         }
        this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/'+data.lkp_art_id+'/'+lkp_berahi_id, {}).then(res => {
          this.juruteknik_list = res
        })
      }
    },
    getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },

    getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },

     tutup(){
         this.$inertia.visit(window.route('art.semakan.index'));
       },
      getbakaAll(){
         this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
           this.lkp_baka = res
         })
       },


  
  },

  watch: {

  },
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.id > 0)
    {
      this.title = 'Tambah Permohonan Perkhidmatan Pembiakan'
    }
    else
    {
      this.title = 'Tambah Permohonan Perkhidmatan Pembiakan'
    }
    this.getPremis()
    this.getJenisTernakan()
    this.getArt()
    this.getData()
    this.getTujuanPd()
    this.lkpBerahi()
    this.getbakaAll()
    // this.getTernakanList()
  }
    
}
</script>
